import * as React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetTitle,
} from 'components/ModalSheet'
import {
  Form,
  FormRow,
  NumericInputContainer,
  TextInputContainer,
} from 'components/inputs'
import { AddManualInvoiceDialogViewModel } from './AddManualInvoiceDialogViewModel'
import Button from '../../../../../components/Button'

interface AddManualInvoiceDialogProps {
  vm: AddManualInvoiceDialogViewModel
}

export default observer(({ vm }: AddManualInvoiceDialogProps) => (
  <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
    <ModalSheetHeader bordered withCloseButton>
      <ModalSheetTitle>Add manual invoice to job</ModalSheetTitle>
    </ModalSheetHeader>

    <ModalSheetContent>
      <ModalSheetContentBlock expanded>
        <Form>
          <FormRow>
            <TextInputContainer
              model={vm}
              field="reason"
              name="reason"
              label="Reason"
              data-test="add-manual-invoice-reason"
              placeholder="e.g. Credit Card on file didn't work. Add the invoice number (INV-XXX)"
              error={vm.validation.getError('reason')}
            />
          </FormRow>

          <FormRow>
            <TextInputContainer
              model={vm}
              field="stripeId"
              name="stripeId"
              label="Stripe Id"
              data-test="add-manual-invoice-stripe-id"
              placeholder="The Stripe Charge Id (ch_XXXXXXXXXXXXXX)."
              error={vm.validation.getError('stripeId')}
            />
          </FormRow>

          <FormRow>
            <NumericInputContainer
              model={vm}
              precision={2}
              field="invoiceAmount"
              name="invoiceAmount"
              label="Invoice amount"
              data-test="add-manual-invoice-amount"
              error={vm.validation.getError('invoiceAmount')}
            />
          </FormRow>
        </Form>
      </ModalSheetContentBlock>
    </ModalSheetContent>

    <ModalSheetFooter>
      <ModalSheetFooterSpacer />
      <ModalSheetFooterButtonGroup>
        <Button
          type="default"
          onClick={vm.close}
          data-test="add-manual-invoice-close-button"
        >
          Close
        </Button>
        <Button
          type="primary"
          data-test="add-manual-invoice-submit-button"
          onClick={vm.add}
        >
          Add Invoice
        </Button>
      </ModalSheetFooterButtonGroup>
    </ModalSheetFooter>
  </ModalSheet>
))
